import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { ModalBody, ModalCloseBtn, ModalFooter, ModalHeader, useModalContext } from '@fiverr-private/overlay';
import { Button } from '@fiverr-private/button';
import { reportClickedOnRequestUpgradeSend } from '../../../events/requestUpgradeEvents';
import { AppI18n } from '../../../utils/i18n';
import { AdminMember } from '../../../types';
import { RequestType } from '../types';
import { AdminBlock } from './AdminBlock';
import { FORM_ID, TextAreaSection } from './TextAreaSection';
import type { RequestUpgradeModalProps } from './RequestUpgradeModal';

interface RequestUpgradeModalContentProps
    extends Pick<RequestUpgradeModalProps, 'pageName' | 'currentPlan' | 'sellerId' | 'upgradeSource'> {
    onSuccessfulRequest: () => void;
    admin: AdminMember;
    requestType: RequestType;
}

export const Content = ({
    onSuccessfulRequest,
    admin,
    pageName,
    requestType,
    currentPlan,
    upgradeSource,
    sellerId,
}: RequestUpgradeModalContentProps) => {
    const { close } = useModalContext();

    const onClickSend = () => {
        reportClickedOnRequestUpgradeSend({ pageName, currentPlan, upgradeSource, sellerId });
    };
    return (
        <>
            <ModalHeader>
                <AppI18n k={`request_upgrade_modal.types.${requestType}.title`} />
                <ModalCloseBtn />
            </ModalHeader>
            <ModalBody>
                <Stack paddingTop="4" paddingBottom="7" gap="8" direction="column">
                    <Container>
                        <Text marginBottom="3">
                            <AppI18n k={`request_upgrade_modal.types.${requestType}.description`} />
                        </Text>
                        <AdminBlock admin={admin} />
                    </Container>
                    <TextAreaSection onSuccessfulRequest={onSuccessfulRequest} requestType={requestType} />
                </Stack>
            </ModalBody>
            <ModalFooter>
                <Button size="lg" intent="secondary" variant="outline" onClick={close}>
                    <AppI18n k={'request_upgrade_modal.cta_cancel'} />
                </Button>
                <Button form={FORM_ID} size="lg" type="submit" onClick={onClickSend}>
                    <AppI18n k={'request_upgrade_modal.cta_send'} />
                </Button>
            </ModalFooter>
        </>
    );
};
